module.exports = __webpack_public_path__ + "static/img/case3-bg.7bf4a38.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/homePage/case3-bg.jpg
// module id = kn9X
// module chunks = 0